"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnalyticsInstance = void 0;
exports.setRudderTyperOptions = setRudderTyperOptions;
exports.withRudderTyperContext = withRudderTyperContext;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * This client was automatically generated. ** Do Not Edit **
 */
var analytics = function analytics() {
  return window.analytics || window.rudderanalytics;
};
/**
 * Updates the run-time configuration of this RudderTyper client.
 *
 * @param {RudderTyperOptions} options - the options to upsert
 *
 * @typedef {Object} RudderTyperOptions
 * @property {Rudder.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
function setRudderTyperOptions(options) {
  analytics = options.analytics ? function () {
    return options.analytics || window.analytics;
  } : analytics;
}
/**
 * Helper to attach metadata on RudderTyper to outbound requests.
 * This is used for attribution and debugging by the RudderStack team.
 */
function withRudderTyperContext() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread(_objectSpread({}, message), {}, {
    context: _objectSpread(_objectSpread({}, message.context || {}), {}, {
      ruddertyper: {
        sdk: 'analytics.js',
        language: 'javascript',
        rudderTyperVersion: '',
        trackingPlanId: 'tp_2VcMepdGsODn30mzqfuBdd60Wrw',
        trackingPlanVersion: '2'
      }
    })
  });
}
var getAnalyticsInstance = exports.getAnalyticsInstance = function getAnalyticsInstance() {
  return analytics();
};